import { render } from "./AppGlobal.vue?vue&type=template&id=e1e9a06e&ts=true"
import script from "./AppGlobal.vue?vue&type=script&lang=ts"
export * from "./AppGlobal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__